import { Navigate } from 'react-router-dom';

import { useAuth } from '../app/AuthProvider';
import { ROLE_HOME } from '../app/RequireRole';
import { useAccountStatus } from '../shared/hooks/useAccountStatus';
import { PageLoader } from '../shared/ui/PageLoader';

/**
 * Post-login dispatcher. Everything interesting — profile completion, the OTP
 * gate, auto-enrolment, the no-role screen — is handled by <AccountGate>, which
 * wraps this route. By the time this renders there is a role, so it only has to
 * pick the right home.
 */
export function AppHomePage(): JSX.Element {
  const { user } = useAuth();
  const { status, loading } = useAccountStatus(user?.id ?? null);

  if (loading || status === null || status.role === null) {
    return <PageLoader label="Finding your workspace…" />;
  }

  // eslint-disable-next-line security/detect-object-injection -- status.role is a typed AppRole union, not user input
  return <Navigate to={ROLE_HOME[status.role]} replace />;
}
